<p-dialog #fileDialog
  appendTo="body"
  (visibleChange)="visibleChange($event)"
  [modal]="true"
  [style]="{width: '70vw'}"
  [baseZIndex]="100"
  [draggable]="false"
  [maximizable]="true"
  [closeOnEscape]="false"
  [(visible)]="isShowFileDialog">

  <div *ngIf="isFileDialogLoading" class="flex justify-content-center">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <ng-template pTemplate="header">
    <label [ngClass]="'p-invalid'" style="margin-left: 30px;">{{ 'ReceivingInstruction.Dialog.File.FileSizeLimit' | translate }}</label>
    <div class='fileDialogModeSwitch' >
      <p-radioButton
        class="margin-right-1"
        label="{{ 'Common.Button.Edit' | translate }}"
        name="fileDialogMode"
        [value]="FILE_DIALOG_MODE_ENUM.Edit"
        [(ngModel)]="fileDialogMode">
      </p-radioButton>

      <p-radioButton
        label="{{ 'Common.Button.FileDownload' | translate }}"
        name="fileDialogMode"
        [value]="FILE_DIALOG_MODE_ENUM.Download"
        [(ngModel)]="fileDialogMode">
      </p-radioButton>
    </div>
    <div>
      <button class='p-dialog-header-icon' (click)="restoreFileDataEvent()" pRipple>
        <span class="pi pi-refresh"></span>
      </button>
    </div>
  </ng-template>

  <div class="flex flex-wrap justify-content-start" *ngIf="!isFileDialogLoading">

    <ng-container *ngIf="isFileDialogInEditMode()">
      <label class='file-add-btn' pRipple>
        <span class="pi pi-plus"></span>
        <input #fileInput
          style="display:none"
          type="file"
          multiple="true"
          (input)="addFileEvent(fileInput)">
      </label>
    </ng-container>

    <div *ngFor="let file of fileList; let index = index">
      <div class="file-block">

        <ng-container *ngIf="isFileDialogInEditMode() else downloadModeTemplate">
          <img *ngIf="isImageTypeFile(file.fileType!); else editableFileIconTemplate"
            [alt]="file.fileName + '.' + file.fileExtension"
            [src]="transformToSafeUrl(file.fileDataUrl)"
            (click)="onFileClick(index)"/>
          <ng-template #editableFileIconTemplate>
            <span class="file-icon pi pi-file-o"></span>
          </ng-template>

          <button *ngIf="filePermission" class='p-dialog-header-icon' (click)="deleteFileEvent(file.docId)" pRipple>
            <span class="pi pi-times-circle"></span>
          </button>
        </ng-container>

        <ng-template #downloadModeTemplate>
          <a [href]="transformToSafeUrl(file.fileDataUrl)"
             [download]="file.fileName + '.' + file.fileExtension">
            <span class="download-mask pi pi-download"></span>
          </a>

          <img *ngIf="isImageTypeFile(file.fileType!); else downloadableFileIconTemplate"
            [alt]="file.fileName + '.' + file.fileExtension"
            [src]="transformToSafeUrl(file.fileDataUrl)"/>

          <ng-template #downloadableFileIconTemplate>
            <span class="file-icon pi pi-file-o"></span>
          </ng-template>

          <button *ngIf="filePermission" class='p-dialog-header-icon' (click)="deleteFileEvent(file.docId)" pRipple>
            <span class="pi pi-times-circle"></span>
          </button>
        </ng-template>

      </div>

      <div class="file-name-block">
        <p>{{file.fileName}}.{{file.fileExtension}}</p>
      </div>

    </div>

  </div>

  <p-galleria
    (visibleChange)="visibleChangeOfGalleria()"
    [value]="fileList"
    [(activeIndex)]="indexOfGalleria"
    [containerStyle]="{'max-width': '80vw'}"
    [circular]="true"
    [fullScreen]="true"
    [showItemNavigators]="true"
    [showThumbnails]="false"
    [baseZIndex]="1000"
    [transitionInterval]="0"
    [(visible)]="isShowBigFile">
    <ng-template pTemplate="item" let-item>
        <img *ngIf="isImageTypeFile(item.fileType); else notImageFileTemplate"
          [src]="transformToSafeUrl(item.fileDataUrl)"
          [alt]="item.fileName + '.' + item.fileExtension"
          style="width: 100%; height: 100%; display: block;"
        />
        <ng-template #notImageFileTemplate>
          <span style="color: white">
            {{item.fileName + '.' + item.fileExtension}} is not a image file
          </span>
        </ng-template>
    </ng-template>
  </p-galleria>

  <div class="flex justify-content-end gap-2">
    <button pButton
      class="p-button-raised mt-2"
      label="{{ 'Common.Button.Save' | translate }}"
      [disabled]="!isAbleToSaveFileChange()"
      (click)="onSaveBtnClickOnFileDialog()"
    ></button>
  </div>
</p-dialog>
